package org.chiangmeng.qfast.core.data.printer

import org.chiangmeng.qfast.core.domain.models.TicketPrintData
import org.chiangmeng.qfast.core.domain.ports.TicketPrinterService

class NoOpTicketPrinterService : TicketPrinterService {
    override suspend fun printTicket(data: TicketPrintData): Boolean {
        println("PRINT_LOG: [Print Ticket] #${data.category}${data.ticketNumber} for ${data.shopName} | Time: ${data.issueTime}")
        return true
    }
}
